import { Component, OnDestroy, OnInit } from '@angular/core';
import { environment } from '../../../environments/local/environment';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { MultiDomainMgmtService } from '../../services/multi-domain-mgmt.service';
import { L1L3AuthService } from 'ngx-auth-util-lib';
import { DomainHandlerService } from '../../services/domain-handler-service';
import { LoadingService } from '../../services/loading/loading.service';
import { HekaAccountMenu } from 'ngx-heka-design-lib';
import { AccountMenuService } from '../../services/account-menu.service';

@Component({
  selector: 'app-no-app-permission',
  templateUrl: './no-app-access.component.html',
  styleUrls: ['./no-app-access.component.scss'],
  standalone: false
})
export class NoAppAccessComponent implements OnInit, OnDestroy {
  description = '';
  private subscriptions = new Subscription();
  accountMenu?: HekaAccountMenu;
  env = environment;


  constructor(private multiDomainMgmtService: MultiDomainMgmtService, private translateService: TranslateService,   public authService: L1L3AuthService,  public domainHandlerService: DomainHandlerService,  public loadingService: LoadingService, private accountMenuService: AccountMenuService,) {}

  ngOnInit(): void {
    this.getProfile();
  }
 private getProfile() {
    this.loadingService.setLoading(true);
    this.subscriptions.add(
      this.multiDomainMgmtService.getSharedMultiDomainProfile().subscribe({
        next: profile => {
          if (profile) {
            this.accountMenu = this.accountMenuService.buildAccountMenu(profile);

            const activeDomain = profile.domains.find(d => d.active);

            if (activeDomain) {
              this.description = this.translateService.instant('OAUTH.NO_ACCESS.DESCRIPTION', {
                companyName: activeDomain.companyName
              });
            }
          }
          this.loadingService.setLoading(false);
        },
        error: err => {
          this.loadingService.setLoading(false);
          throw err;
        }
      })
    );
  }


  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  goToMHP() {
    window.open(environment.links.applications.hcp.host, '_self');
  }
}
